module.exports = __webpack_public_path__ + "files/4b298b1c7a497ebdfac75dc1de620980.png";